module.exports = __webpack_public_path__ + "img/eversource-wealth-advisors.5c90f177.svg";